import get from 'lodash.get';

import template from './providersElement.html' with { type: 'html' };

export default {
	name: 'CProvidersElement',
	props: {
		element: {
			type: String,
			validator: (value) => [
				'bancontact',
				'creditcard',
				'iban'
			].includes(value)
		},
		iframeTitle: {
			type: String,
			default: ''
		},
		isNewMethod: {
			type: Boolean,
			default: false
		},
		order: {
			type: Object,
			default: () => null
		},
		paymentType: {
			type: String,
			validator: (value) => [
				'creditCard',
				'directDebit',
				'bancontact'
			].includes(value)
		},
		placeholder: {
			type: String,
			default: ''
		},
		selectedPayment: {
			type: Object,
			default: () => null
		},
		theme: {
			type: Object,
			default: () => null
		},
		url: {
			type: Object,
			default: () => null
		}
	},
	data() {
		return {
			input: null,
			ready: false
		};
	},
	computed: {
		hppIframeOrigin() {
			return get(this.providersLibrary, 'payment.TARGET', '').split('/', 3).join('/');
		},
		isCreditCard() {
			return this.selectedPayment?.type === 'creditCard';
		},
		isAuthenticatedNoNewMethod() {
			return this.order.isAuthenticated && !this.isNewMethod;
		}
	},
	mounted() {
		// Listen to input events and pass them to component events
		this.listenToEvents();
		// Set iframe title - accessibility
		const iframe = this.$el.getElementsByTagName('iframe');
		if (iframe && iframe.length) {
			iframe[0].setAttribute('title', this.iframeTitle);
		}
	},
	methods: {
		listenToEvents() {
			window.addEventListener('message', (event) => {
				// Don't listen any other messages but HPP
				if (event.origin !== this.hppIframeOrigin || !event.data.type) {
					return;
				}
				// Unify HPP event messages
				const eventName = event.data.type.toLowerCase().replace(/(app_)+(event|hpp_dom)_/, '').replace(/focus_out/, 'blur');
				const payload = event.data.payload ?? {};
				// Unify element type names (HPP = number, expiration, cvc)
				const creditCardNumber = ['number'].includes(payload.elementType) ? 'cardnumber' : '';
				const creditCardExpiration = ['expiration'].includes(payload.elementType) ? 'cardexpiration' : '';
				const creditCardCvc = ['cvc'].includes(payload.elementType) ? 'cardcvv' : '';
				// Emit event
				this.emitEvent(eventName, Object.assign({}, payload, {
					elementType: creditCardNumber || creditCardExpiration || creditCardCvc || payload.elementType
				}));
			}, false);
		},
		autoFocus() {
			// Provider has not implemented handler for this method
		},
		focus() {
			// Provider has not implemented handler for this method
		},
		clear(elementName) {
			const clearField = window.clearField;
			if (clearField) {
				// CVC = 'ccCVC', Expiration Date = 'ccExpDate', Card number = 'ccNumber'
				clearField(elementName);
			}
		},
		reset() {
			// Provider has not implemented handler for this method
		},
		emitEvent(name, data) {
			const elementType = data?.elementType ?? this.element;
			if (name === 'ready') { // Store the created input into Vuex store
				this.ready = true;
				if (this.paymentType === 'creditCard') {
					this.$store.commit('SET_SELECTED_PAYMENT', {
						cardcvv: {
							clear: () => this.clear('ccCVC')
						},
						cardexpiration: {
							clear: () => this.clear('ccExpDate')
						},
						cardnumber: {
							clear: () => this.clear('ccNumber')
						}
					});
				}
				if (this.paymentType === 'bancontact') {
					this.$store.commit('SET_SELECTED_PAYMENT', {
						cardexpiration: {
							clear: () => this.clear('ccExpDate')
						},
						cardnumber: {
							clear: () => this.clear('ccNumber')
						}
					});
				}
				if (this.paymentType === 'directDebit') {
					this.$store.commit('SET_SELECTED_PAYMENT', {
						iban: {
							clear: () => this.clear('ddIBAN')
						}
					});
				}
				// Reset form so there are default states on every new load of those inputs
				this.$store.commit('SET_FORM', {
					creditCard: null,
					bancontact: null,
					directDebit: null
				});
				this.$store.commit('SET_PAYMENT', {
					...this.$store.state.payment,
					isHPPReady: true
				});
			} else if (elementType === 'cardnumber' && name === 'change') { // When card number changes, store the card provider into store
				this.$store.commit('SET_SELECTED_PAYMENT', {
					cardBrand: data.brand || data.cardType.toLowerCase()
				});
			}
			this.$emit('input-status', {
				data,
				name
			});
			this.$emit(name, data);
		}
	},
	template
};
